import { MAIN_SERVER } from './instance'
import { UTILS__VALIDATOR__is_value } from '../utils/validator'
import store from '../store'

export const GET_PROJECTS = async obj => {
    try {
        const params = {}

        const {
            user: { optionalId = null },
        } = store.getState()
        if (optionalId) {
            params.userId = optionalId
        }

        if (UTILS__VALIDATOR__is_value(obj.status)) {
            params.status = obj.status
        }
        if (UTILS__VALIDATOR__is_value(obj.perPage)) {
            params.size = obj.perPage
        }
        if (UTILS__VALIDATOR__is_value(obj.offsetPages)) {
            params.page = obj.offsetPages
        }
        if (UTILS__VALIDATOR__is_value(obj.sort)) {
            params.sort = obj.sort
        }

        return await MAIN_SERVER({
            method: 'get',
            url: `/projects`,
            params,
        })
    } catch (err) {
        throw err
    }
}

export const GET_PROJECTS_COUNT = async () => {
    const params = {}

    const {
        user: { optionalId = null },
    } = store.getState()
    if (optionalId) {
        params.userId = optionalId
    }

    try {
        return await MAIN_SERVER({
            method: 'get',
            url: `/projects/count-by-status`,
            params,
        })
    } catch (err) {
        throw err
    }
}

export const GET_PROJECT = async project_id => {
    try {
        return await MAIN_SERVER({
            method: 'get',
            url: `/projects/${project_id}`,
        })
    } catch (err) {
        throw err
    }
}

export const SET_PROJECT_PREVIEW_IMAGE = async (project_id, image_id) => {
    try {
        const params = {}
        const data = {}

        const {
            user: { optionalId = null },
        } = store.getState()
        if (optionalId) {
            params.userId = optionalId
        }

        return await MAIN_SERVER({
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
            },
            url: `/projects/${project_id}/preview-image/${image_id}`,
            params,
            data,
        })
    } catch (err) {
        throw err
    }
}

export const SAVE_PROJECT = async obj => {
    try {
        const params = {}
        const data = { ...obj }

        const {
            user: { optionalId = null },
        } = store.getState()
        if (optionalId) {
            params.userId = optionalId
        }

        return await MAIN_SERVER({
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
            },
            timeout: 30000,
            url: `/projects`,
            params,
            data,
        })
    } catch (err) {
        throw err
    }
}

export const DELETE_PROJECT = async project_id => {
    try {
        const params = {}

        const {
            user: { optionalId = null },
        } = store.getState()
        if (optionalId) {
            params.userId = optionalId
        }

        return await MAIN_SERVER({
            method: 'delete',
            url: `/projects/${project_id}`,
            params,
        })
    } catch (err) {
        throw err
    }
}

export const UPDATE_PROJECT = async (projectId, obj) => {
    try {
        const params = {}
        const data = { ...obj }

        const {
            user: { optionalId = null },
        } = store.getState()
        if (optionalId) {
            params.userId = optionalId
        }

        return await MAIN_SERVER({
            method: 'put',
            headers: {
                'Content-Type': 'application/json',
            },
            timeout: 30000,
            url: `/projects/${projectId}`,
            params,
            data,
        })
    } catch (err) {
        throw err
    }
}

export const PUBLISH = async (id, lng) => {
    try {
        const params = {}
        const data = {}

        const {
            user: { optionalId = null },
        } = store.getState()
        if (optionalId) {
            params.userId = optionalId
        }

        if (UTILS__VALIDATOR__is_value(lng)) {
            data.languageCode = lng.toUpperCase()
        } else {
            const { language } = store.getState()
            data.languageCode = language.split('-')[0].toUpperCase()
        }

        return await MAIN_SERVER({
            method: 'patch',
            url: `/projects/${id}/publish`,
            params,
            data,
        })
    } catch (err) {
        throw err
    }
}

export const GET_DEFAULT_PREVIEW_IMAGE = async () => {
    try {
        const data = {}
        const params = {}

        return await MAIN_SERVER({
            method: 'get',
            headers: {
                'Content-Type': 'text/plain',
            },
            url: '/projects/preview/default-preview-image',
            params,
            data,
        })
    } catch (err) {
        throw err
    }
}

export const SET_DEFAULT_PREVIEW_IMAGE = async projectId => {
    try {
        const data = {}
        const params = {}

        return await MAIN_SERVER({
            method: 'patch',
            url: `/projects/${projectId}/default-preview-image`,
            params,
            data,
        })
    } catch (err) {
        throw err
    }
}

export const CHECK_CUSTOM_URL = async value => {
    try {
        const data = {}
        if (UTILS__VALIDATOR__is_value(value)) {
            data.customUrl = value
        }

        return await MAIN_SERVER({
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
            },
            timeout: 30000,
            url: '/projects/custom-url/check',
            data,
        })
    } catch (err) {
        throw err
    }
}

export const SET_CUSTOM_URL = async (project_id, value) => {
    try {
        const data = {}
        if (UTILS__VALIDATOR__is_value(value)) {
            data.customUrl = value
        }

        return await MAIN_SERVER({
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
            },
            timeout: 30000,
            url: `/projects/${project_id}/custom-url`,
            data,
        })
    } catch (err) {
        throw err
    }
}

export const DELETE_CUSTOM_URL = async project_id => {
    try {
        return await MAIN_SERVER({
            method: 'delete',
            url: `/projects/${project_id}/custom-url`,
        })
    } catch (err) {
        throw err
    }
}

export const SHARE = async (projectId, entities) => {
    try {
        const params = {}
        const data = [...entities]

        const {
            user: { optionalId = null },
        } = store.getState()
        if (optionalId) {
            params.userId = optionalId
        }

        return await MAIN_SERVER({
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
            },
            url: `/projects/${projectId}/share`,
            params,
            data,
        })
    } catch (err) {
        throw err
    }
}

export const SEND_CONSTRAINT = async (actionTypeName, projectId, blockId, body = {}) => {
    return MAIN_SERVER({
        method: 'put',
        url: `/actions/constraints/${actionTypeName}/project-id/${projectId}/block-id/${blockId}`,
        data: {
            actionTypeName,
            projectId,
            blockId,
            ...body,
        },
    })
}

export const REMOVE_CONSTRAINT = async (actionTypeName, projectId, blockId) => {
    try {
        await MAIN_SERVER({
            method: 'delete',
            url: `/actions/constraints/${actionTypeName}/project-id/${projectId}/block-id/${blockId}`,
        })
    } catch (err) {
        if (err.response) {
            if (err.response.status === 404) return
        }
        throw err
    }
}

export const SET_EMAIL_INTEGRATION = async (email, projectId) => {
    try {
        const params = {}

        const {
            user: { optionalId = null },
        } = store.getState()
        if (optionalId) {
            params.userId = optionalId
        }

        await MAIN_SERVER({
            method: 'patch',
            url: `/integrations/EMAIL/projects/${projectId}`,
            params,
            data: [
                {
                    key: 'NOTIFICATION_EMAIL',
                    value: email,
                },
            ],
        })
    } catch (err) {
        throw err
    }
}

export const DISABLE_EMAIL_INTEGRATION = async projectId => {
    try {
        const params = {}

        const {
            user: { optionalId = null },
        } = store.getState()
        if (optionalId) {
            params.userId = optionalId
        }

        await MAIN_SERVER({
            method: 'patch',
            url: `/integrations/EMAIL/projects/${projectId}/disable`,
            params,
            data: {},
        })
    } catch (err) {
        throw err
    }
}
